import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=535cb9d0"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=535cb9d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports